import { forwardRef, useEffect, useState, useRef } from "react";
import "./Contact.css";
import { IoLogoWhatsapp } from "react-icons/io";
import { SiGmail } from "react-icons/si";
import AOS from "aos";
import emailjs from "@emailjs/browser";
import { LuLoader2 } from "react-icons/lu";
import Copy from "../../icons/Copy/Copy";

const Contact = forwardRef((props, ref) => {
  const telefono = "+54 911 6278-7796";
  const email = "cancelarte.info@gmail.com";
  const [error, setError] = useState("");
  const [resultForm, setResultForm] = useState("");
  const [loading, setLoading] = useState(false);

  const copiarTelefonoAlPortapapeles = () => {
    navigator.clipboard.writeText(telefono);
  };

  const copiarEmailAlPortapapeles = () => {
    navigator.clipboard.writeText(email);
  };

  const form = useRef();
  const onClickWhatsapp = () => {
    const url = `https://api.whatsapp.com/send?phone=${telefono}&text=Hola quiero saber más sobre sus servicios`;
    window.open(url, "_blank");
  };

  const onClickMail = () => {
    const url = `mailto:${email}?Subject=Contacto de sitio cancelarte`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  const validateForm = (userName, userEmail, message) => {
    if (!userName) {
      setError("Por favor ingrese su nombre");
      return false;
    }

    if (!userEmail) {
      setError("Por favor ingrese su email");
      return false;
    }

    if (!message) {
      setError("Por favor ingrese su mensaje");
      return false;
    }

    setError("");
    return true;
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setResultForm("");
    setLoading(true);

    const userName = form.current["user_name"].value;
    const userEmail = form.current["user_email"].value;
    const message = form.current["message"].value;

    const validation = validateForm(userName, userEmail, message);

    if (validation) {
      const templateParams = {
        user_name: userName,
        user_email: userEmail,
        message: message,
        to_email: email,
      };

      try {
        const result = await emailjs.send(
          "service_3h60n9s",
          "template_fh227dm",
          templateParams,
          "GWuxvaRx94LtGuDQr"
        );

        if (form.current) {
          form.current.reset();
        }

        if (result.status === 200 && result.text === "OK") {
          setResultForm("Mensaje enviado correctamente");
        } else {
          setError(result?.text || "Ocurrió un error al enviar el mensaje");
        }
      } catch (error) {
        setError(error?.text || "Ocurrió un error al enviar el mensaje");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 200);
      }
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 400);
    }
  };

  return (
    <div ref={ref} id={4} className="container contact-component">
      <div className="contact-content">
        <div
          className="text-content"
          data-aos="fade-right"
          data-aos-once="true"
        >
          <span className="title-section">Solicita tu informe gratis AQUÍ</span>
          <p className="loan-description">
            Contactanos hoy y contanos tu situación. Estamos para escucharte y
            ayudarte.
          </p>
        </div>

        <div
          className="form-container"
          data-aos="fade-left"
          data-aos-once="true"
        >
          {/*<div className="topic-text">Apply now!</div>*/}
          <form ref={form} onSubmit={sendEmail} action="#">
            <div className="input-box">
              <input
                name="user_name"
                type="text"
                placeholder="Nombre y apellido"
              />
            </div>
            <div className="input-box">
              <input name="user_email" type="email" placeholder="Email" />
            </div>
            <div className="input-box message-box">
              <textarea
                name="message"
                placeholder="Mensaje"
                rows={4}
              ></textarea>
            </div>
            <div className="button-send button-blue">
              <button
                type="submit"
                disabled={loading}
                className={loading ? "loading" : ""}
              >
                {loading ? (
                  <LuLoader2
                    size={20}
                    style={{ animation: "spin 0.6s linear infinite" }}
                  />
                ) : (
                  "Contactar!"
                )}
              </button>
              {resultForm && (
                <p className="form-message success">{resultForm}</p>
              )}
              {error && (
                <p className="form-message error">{error}</p>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
});

export default Contact;
